import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ImageAssetsService } from '@services/assets/image-assets.service';
import { FileAssetsService } from '@services/assets/file-assets.service';
import { Models } from '@ibexfusion/models';
import { MessengerService } from '@services/messenger/messenger.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';

import { MediaAssetsService } from '@services/assets/media-assets.service';
import { DialogService } from '@services/dialog/dialog.service';
import { EnvironmentService } from '@services/environment/environment.service';
import { TranslateService } from '@services/translate/translate.service';
import { UploaderService } from '@services/uploader/uploader.service';
import { HttpClient } from '@angular/common/http';
import { VideoAssetsPropertiesService } from '@services/video-assets/video-assets-properties.service';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import * as _ from 'lodash';

@Component({
  selector: 'assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss'],
  providers: [ImageAssetsService, FileAssetsService, VideoAssetsPropertiesService, MediaAssetsService,
    DynamicContentService, DynamicContentEntranceService, PackageInstalledAppsService],
  standalone: false
})
export class AssetsComponent implements OnInit, OnChanges {

  @Input() type: string;
  @Input() disableCheckSize = false;
  @Input() content;
  @Input() showAll;
  @Input() title;
  @Input() packageId;
  @Input() isModal = false;
  @Input() parentTitle = '';
  @Input() multiple = true;
  @Input() dynamicContent: any;
  @Input() entrances: any;
  @Output() select = new EventEmitter<any>();
  @Output() selectForModal = new EventEmitter<any>();
  @Output() changeTabModal = new EventEmitter<any>();
  public systemMessages: any;
  public mediaTranslate: any;

  assetPath: string;
  allowedMimetypes: string;
  options = { checkExists: true };

  assets: Models.AssetBaseModel[] | any;
  defAssets: Models.AssetBaseModel[];

  assetsService: any;

  isUploading;
  isLoading = true;
  progress: any;
  timestamp;

  skip = 0;
  limit = { 'image': 12, 'video': 5, 'file': 8, 'media': 12 };
  count: number;

  params: any;

  imageView = 'grid';
  selectedItems = [];
  checkBoxActions: any[];
  sortByDate = false;
  sortByTitle = false;
  data;
  children = [];

  types = {
    image: ['jpg', 'jpeg', 'png', 'svg', 'gif', 'bmp', 'webp', 'tiff', 'ico'], media: ['jpg', 'jpeg', 'png', 'svg', 'gif', 'bmp', 'webp', 'tiff', 'ico'],
    video: ['mp4', 'avi', 'mkv', 'mov', 'mpeg', '3gp', 'ogg'], file: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv', 'rtf']
  };

  sortWay = {0: 'ASC', 1: 'DESC', 2: 'NO'};
  currentStep = 0;

  constructor(
    private imageAssetsService: ImageAssetsService, private fileAssetsService: FileAssetsService, private videoAssetsService: VideoAssetsPropertiesService,
    private mediaAssetsService: MediaAssetsService, private ms: MessengerService, private dialogService: DialogService, private environmentService: EnvironmentService,
    private ts: TranslateService, private dynamicContentService: DynamicContentService, private dynamicContentEntranceService: DynamicContentEntranceService,
    private snackbar: SnackbarService, private http: HttpClient, private appService: PackageInstalledAppsService
  ) {
    this.params = {
      deleted: { $ne: true }, createdByImport: { $ne: true }, OwnerOrganisationID: this.ms.getOrganisation().OrganisationID, $sort: { created: -1 }, path: { $in: [] }
    };
  }

  async ngOnInit() {
    this.systemMessages = this.ts.get('system');
    this.mediaTranslate = this.ts.get('resources');
    this.timestamp = new Date().getTime();
    this.checkBoxActions = [{ title: 'dynamicContent.deleteSelected', icon: 'delete', callback: (items) => {this.deleteSelected(items)} }];
  }

  async deleteSelected(items) {
    const translationsAll = this.ts.get('dynamicContent');
    let question = translationsAll['deleteSelectedQuestion'];
    if (this.type === 'image') {
      question = !!items?.filter(el => el.isInContent)?.length ? this.mediaTranslate.deleteUsedImages : items.length > 1 ?
        this.mediaTranslate.deleteImages : this.mediaTranslate.deleteImage;
    }
    const res = await this.dialogService.confirm(question);
    if (res) {
      const promises = items.map(item => this.assetsService.patch(item._id, { deleted: true }));
      const inContent = items.filter(i => !!i.isInContent);
      for (let asset of inContent || []) {
        await this.deleteAssetFromContent(asset);
      }
      await Promise.all(promises);
      this.clearSelect();
      this.loadAssets();
    }
  }

  clearSelect() {
    this.selectedItems = [];
    const selectAllCheckbox: any = document.getElementById('selectAll');
    if (selectAllCheckbox) {
      selectAllCheckbox.checked = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!Object.keys(changes).find(key => JSON.stringify(changes[key].currentValue) !== JSON.stringify(changes[key].previousValue))) {
      return this.init();
    }
  }

  init() {
    this.assets = [];
    this.defAssets = [];
    this.params.path.$in = this.showAll ? [] : this.content.map(mediaFile => mediaFile.url);
    if (this.showAll || this.params.path.$in.length) {
      this.loadAssets();
    }
  }

  async loadAssets() {
    const configMap = {
      image: { path: this.environmentService.getImageAssetPath(), mimetype: 'image/*', options: { checkSize: !this.disableCheckSize } },
      file: { path: this.environmentService.getFileAssetPath(), mimetype: 'application/pdf' },
      video: { path: this.environmentService.getVideoAssetPath(), mimetype: 'video/mp4' },
      media: { path: this.environmentService.getMediaAssetPath(), mimetype: '*/*' }
    };
    this.getAssetService();
    const config = configMap[this.type];
    if (!config) {
      return;
    }
    this.isLoading = true;
    this.assetPath = config.path;
    this.allowedMimetypes = config.mimetype;
    if (config.options) {
      Object.assign(this.options, config.options);
    }
    const result = await this.getBatchWise(this.params, 50);
    this.assets = result.data || result;
    this.defAssets = JSON.parse(JSON.stringify((this.assets)));
    this.count = result.total;
    this.isUploading = false;
    if (!this.isModal) {
      this.getContent();
    } else {
      this.assets.forEach(asset => {
        asset.isInContent = !!this.dynamicContent?.mediaFiles?.find(mf => mf.url === asset.path);
      });
      this.isLoading = false;
    }
  }

  async getBatchWise(params, batchSize) {
    const p = JSON.parse(JSON.stringify(params));
    if (!p.path.$in.length) {
      let data: any[] = [];
      let skip = 0;
      let res;
      do {
        res = await this.getAssetService().find(skip, batchSize, p);
        data = data.concat(res.data);
        skip += batchSize;
      } while (data.length < res.total);
      return { data, total: data.length };
    }
    const pathBatches = [];
    for (let i = 0; i < p.path.$in.length; i += batchSize) {
      pathBatches.push(params.path.$in.slice(i, i + batchSize));
    }
    let data = [];
    let total = 0;
    for (let batch of pathBatches) {
      p.path.$in = batch;
      const result = await this.getAssetService().find(0, batch.length, p);
      data = data.concat(result.data);
      total += result.total;
    }
    return { data, total };
  }

  async uploadAsset(event): Promise<any> {
    const src = event.target || event.srcElement;
    const element = event.path ? event.path[0] : event.target;
    if (!src.files.length) {
      return;
    }
    const wrongType = Array.from(element?.files || [])?.filter((f: any) => !this.types[this.type].includes(f?.name?.split('.')?.[f?.name?.split('.')?.length - 1]?.toLowerCase()));
    if (wrongType?.length) {
      this.snackbar.warn('Die folgenden Dateien konnten nicht hochgeladen werden, da sie den falschen Dateitypen haben: ' + wrongType.map((f: any) => f?.name).join(', '), 5000);
    }

    this.isUploading = true;
    if (this.type === 'video') {
      const uploader = new UploaderService(this.http, this.ms, { file: src.files[0], fileName: src.files[0].name });
      const alreadyExists = await uploader.checkUpload();
      uploader.onProgress(prog => {
        this.progress = prog.percentage;
      });
      uploader.onFinish(key => {
        return this.assetsService.create(this.makeAssetReady(key, src.files[0], true)).then(res => {
          element.value = null;
          this.isUploading = false;
          this.loadAssets();
        }).catch(err => {
          this.progress = null;
          this.isUploading = false
          this.loadAssets();
        });
      });
      if (alreadyExists) {
        const info = this.systemMessages.assets.alreadyExists;
        const confirm = this.systemMessages.assets.confirmExists
        return this.dialogService.confirm(info + '<br/>' + confirm).then(res => {
          if (!res) {
            return;
          }
          uploader.start();
        });
      } else {
        uploader.start();
      }
    } else {
      for (const file of src.files) {
        if (!this.types[this.type].includes(file?.name?.split('.')?.[file?.name?.split('.')?.length - 1]?.toLowerCase())) {
          continue;
        }
        const renderResult = await this.readAsDataURL(file);
        await this.saveAsset(this.makeAssetReady(renderResult, file));
        this.isUploading = true;
      }
      element.value = null;
      this.isUploading = false;
    }
  }

  async saveAsset(asset) {
    const service = this.getAssetService();
    try {
      const val = await (service as any).create(asset, { query: { timeout: 60 * 1000 } });
      await this.loadAssets();
      if (!!this.isModal) {
        this.selectedItems.push(val);
        this.selectForModal.emit(this.selectedItems);
      }
      return true;
    } catch (err) {
      this.isUploading = false;
      console.log('save asset catched err: ', err);
      try {
        let message = this.parseIfPossible(err?.error?.message || err?.responseText || err)?.data || this.parseIfPossible(err?.error?.message || err?.responseText || err);
        if (message?.rejected) {
          const info = message?.reason === 'existing' ? this.systemMessages.assets.alreadyExists : (message?.reason === 'size' ? (message?.orientation === 'portrait' ? this.systemMessages.assets.infoImageSizePortrait : this.systemMessages.assets.infoImageSizeLandscape) + message?.width + ' x ' + message?.height + ' Pixel' : undefined);
          const confirm = ['existing', 'size'].includes(message?.rease) ? this.systemMessages.assets.confirmExists : undefined;
          const action = message?.reason === 'existing' ? 'checkExists' : (message?.reason === 'size' ? 'checkSize' : undefined);
          const res = await this.dialogService.confirm(info + '<br/>' + confirm);
          if (!res) {
            return;
          }
          asset.options[action] = false;
          this.isUploading = true;
          return this.saveAsset(asset);
        }
      } catch (err) {
        console.log(err);
        const error = err && err.error ? err.error.message : err;
        this.snackbar.error('Could not upload: ' + error, 5000);
      }
    }
  }

  parseIfPossible(value) {
    try {
      value = JSON.parse(value);
    } catch (err) {
      console.warn(err);
    }
    return value;
  }

  getAssetService(): any {
    const services = { image: this.imageAssetsService, file: this.fileAssetsService, video: this.videoAssetsService, media: this.mediaAssetsService };
    if (!this.assetsService || this.assetsService !== services[this.type]) {
      this.assetsService = services[this.type] || this.mediaAssetsService;
    }
    return this.assetsService;
  }

  saveVideoAsset(asset, src) {
    this.assetsService.create(asset).then(result => {
      if (result?.meta?.status === 'started') {
        const interval = setInterval(() => {
          this.assetsService.get(encodeURIComponent(result.meta.key)).then(status => {
            if (status && status.meta && status.meta.status === 'progress') {
              this.progress = status.meta;
            } else if (status && status.meta && status.meta.status === 'finished') {
              this.assets.unshift(status.meta.file);
              this.progress = null;
              this.isUploading = false;
              src.files = null;
              clearInterval(interval);
            } else if (status && status.meta && status.meta.status === 'failed') {
              this.progress = null;
              this.isUploading = false;
              console.error(status.meta.error);
              src.files = null;
              clearInterval(interval);
            }
          }).catch(err => {
            console.log('error on getting asset service status', err);
            clearInterval(interval)
          });
        }, 500);
      } else if (result?.meta?.rejected && result?.meta?.reason === 'existing') {
        return this.dialogService.confirm(this.systemMessages.assets.alreadyExists + '<br/>' + this.systemMessages.assets.confirmExists).then(res => {
          if (!res) {
            this.isUploading = false;
            return;
          }
          asset.options['checkExists'] = false;
          this.isUploading = true;
          return this.saveVideoAsset(asset, src);
        });
      } else {
        console.log('we have no result', result);
        this.isUploading = false;
      }
    }).catch(err => {
      this.isUploading = false;
      this.snackbar.error('Could not upload video: ', err.message);
      console.error(err);
    });
  }

  makeAssetReady(readerResult, file, video = false) {
    const asset = new Models.AssetBaseModel();
    if (video) {
      asset.data = { key: readerResult.split('assets/videos/').pop() };
      asset.path = readerResult.split('assets/videos/').pop();
    } else {
      asset.data = (typeof readerResult === 'string' ? readerResult : readerResult.toString());
    }
    asset.originalFileName = file.name;
    asset.mimeType = file.type;
    asset.fileSize = file.size;
    asset.extension = file.name.split('.').pop();
    asset.options = JSON.parse(JSON.stringify((this.options)));
    return asset;
  }

  readAsDataURL(file) {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onerror = () => reject(fr.error);
      fr.onload = () => resolve(fr.result);
      fr.readAsDataURL(file);
    });
  }

  selectAsset(selectedAsset: any, type: string) {
    this.select.emit({ asset: selectedAsset, type: this.type });
    if (this.isModal) {
      this.selectItem(selectedAsset);
    }
  }

  updateAssets(image) {
    let index = this.assets.findIndex(el => el._id === image._id);
    image.contentIds = image.contentIds || JSON.parse(JSON.stringify(this.assets[index]?.contentIds || []));
    image.isInContent = image.isInContent || JSON.parse(JSON.stringify(this.assets[index]?.isInContent || []));
    if (index >= 0) {
      this.assets[index] = image;
    }
  }

  downloadFile(asset) {
    const a = Object.assign(document.createElement('a'), { href: this.assetPath + asset.path + '?' + this.timestamp, download: asset.originalFileName, target: '_blank' });
    a.click();
    a.remove();
  }

  async flagAsDeleted(asset, type) {
    let msg = this.mediaTranslate.deleteItem;
    if (type === 'image') {
      msg = this.mediaTranslate.deleteImage;
      if (asset.isInContent) {
        msg = this.mediaTranslate.deleteUsedImage;
      }
    }
    if (!(await this.dialogService.confirm(msg))) {
      return;
    }
    if (asset.isInContent) {
      await this.deleteAssetFromContent(asset);
    }
    await this.assetsService.patch(asset._id, { deleted: true });
    this.init();
  }

  async deleteAssetFromContent(asset) {
    const entries = await this.dynamicContentService.find(0, 1000, { $or: [{ 'mediaFiles.url': asset.path }, { 'dataFiles.url': asset.path }] });
    for (let entry of entries?.data || []) {
      await this.dynamicContentService.patch(entry._id, {
        mediaFiles: entry.mediaFiles.filter(f => f.url !== asset.path), dataFiles: entry.dataFiles.filter(f => f.url !== asset.path)
      });
    }
  }

  round(float: any) {
    return Math.round(float * 100) / 100;
  }

  changeView(view) {
    this.imageView = view;
  }

  sort(type) {
    this.sortByTitle = type === 'title';
    this.sortByDate = type === 'date';
    if (this.currentStep !== 2) {
      const searchField = this.sortByTitle ? 'originalFileName' : 'created';
      this.assets = this.assets.sort((a, b) => {
        if (this.sortByTitle) {
          if (this.sortWay[this.currentStep] === 'ASC') {
            return a[searchField].localeCompare(b[searchField]);
          } else {
            return b[searchField].localeCompare(a[searchField]);
          }
        } else {
          if (this.sortWay[this.currentStep] === 'ASC') {
            return new Date(b.created).getTime() - new Date(a.created).getTime();
          }
          return new Date(a.created).getTime() - new Date(b.created).getTime();
        }
      });
    } else {
      this.assets = JSON.parse(JSON.stringify((this.defAssets)));
    }
    this.currentStep = (this.currentStep + 1) % 3;
  }

  selectAllItem(event: any) {
    const elements = Array.from(document.querySelectorAll('.checkbox-list-container input'));
    for (const element of elements) {
      if (event.target !== element) {
        (<any>element).checked = !!event.target.checked;
      }
    }
    this.selectedItems = event?.target.checked ? JSON.parse(JSON.stringify((this.assets))) : [];
    this.selectForModal.emit(this.selectedItems);
  }

  async selectItem(asset) {
    const isSelected = !!this.selectedItems.find(el => el._id === asset._id);
    this.selectedItems = isSelected ? this.selectedItems.filter(el => el._id !== asset._id) : this.selectedItems;
    if (!isSelected) {
      if (this.isModal && await this.isSecured(asset)) {
        const confirmRes = await this.dialogService.confirm(this.systemMessages.assets.confirmSecured);
        if (!confirmRes) {
          const input: any = document.getElementById(asset._id);
          if (input) {
            input.checked = false;
          }
          return;
        }
      }
      !!this.multiple ? this.selectedItems.push(_.cloneDeep(asset)) : this.selectedItems = [_.cloneDeep(asset)];
    }
    this.selectForModal.emit(this.selectedItems);
  }

  async isSecured(asset): Promise<boolean> {
    if (!this.ms.$activePrivileges.getValue().find(r => r.value === 'dynamic-contents')) {
      return false;
    }
    const attachedEntries = (await this.dynamicContentService.find(0, 50, { $or: [{ 'mediaFiles.url': asset.path }, { 'dataFiles.url': asset.path }] })).data;
    for (const content of attachedEntries) {
      const entrance = await this.getEntrance(content._id);
      const app = entrance ? await this.appService.find(0, 1, { dynamicContentEntranceId: entrance._id }) : null;
      if (!!app?.data?.[0]?.isSecured) {
        return true;
      }
    }
    return false;
  }

  async getEntrance(id): Promise<any> {
    const entrance = (await this.dynamicContentEntranceService.find(0, 1, { children: id })).data?.[0];
    if (!!entrance) {
      return entrance;
    }
    const content = (await this.dynamicContentService.find(0, 1, { children: id })).data?.[0];
    return !!content?._id ? this.getEntrance(content?._id) : null;
  }

  isChecked(element) {
    return !!this.selectedItems.find(el => el._id === element._id);
  }

  executeSelectedAction(action) {
    action.callback(this.selectedItems);
  }

  getContent() {
    this.isLoading = true;
    this.ms.$activeContents.subscribe(contents => {
      this.isLoading = true;
      if (!this.ms.getOrganisation()) {
        return;
      }
      const query = <any>{ OwnerOrganisationID: this.ms.getOrganisation().OrganisationID };
      if (contents && contents.length) {
        query['_id'] = { $in: contents.map(el => el.dynamicContentEntrance_Id) }
      }
      this.getDynamicContentEntrances(query);
    });
  }

  public async getDynamicContentEntrances(query) {
    try {
      const result = this.entrances ? { entrances: this.entrances } : await this.dynamicContentEntranceService.findAssigned(0, 100, query, { packageIds: this.packageId });
      if (!result?.entrances) {
        this.isLoading = false;
        return;
      }
      const ids = result.entrances.map(el => el._id).filter(id => !!id);
      for (let id = 0; id < ids.length; id++) {
        const entrancesQuery = { entranceId: ids[id], withSubs: true };
        const tree = [];
        let entrances = await this.dynamicContentService.find(0, 1000, entrancesQuery);
        if (!entrances?.data?.length) {
          this.data = tree;
          this.isLoading = false;
          continue;
        }
        (entrances.children || []).forEach(child => {
          const item = new Models.DynamicContent();
          item.populateFromJSON(child);
          this.children[child._id] = item;
        });
        entrances.data = entrances.data.filter(el => !el?.content?.date?.includes('Invalid'));
        entrances.data.forEach((entry, i) => { tree.push(this.pushToTree(entrances.data[i], 1)); });
        this.data = tree;
        this.findMedia(this.data);
      }
      this.isLoading = false;
    } catch (err) {
      console.log('Error: ', err.message);
    }
  }

  findMedia(data) {
    for (let i = 0; i < data.length; i++) {
      if (['image', 'video', 'media'].includes(this.type)) {
        for (let m = 0; m < data?.[i]?.data?.mediaFiles?.length || 0; m++) {
          const asset = this.assets.find(el => el.path === data[i].data.mediaFiles[m].url);
          if (asset) {
            asset.isInContent = true;
            if (!asset.contentIds) {
              asset.contentIds = [];
            }
            asset.contentIds.push(data[i].data._id);
          }
        }
        for (let m = 0; m < data?.[i]?.data?.content?.slides?.length || 0; m++) {
          const asset = this.assets.find(el => el.path === data[i].data.content.slides[m].value);
          if (asset) {
            asset.isInContent = true;
            if (!asset.contentIds) {
              asset.contentIds = [];
            }
            asset.contentIds.push(data[i].data._id);
          }
        }
      }
      if (this.type === 'file') {
        for (let m = 0; m < data?.[i]?.data?.dataFiles?.length || 0; m++) {
          const asset = this.assets.find(el => el.path === data[i].data.dataFiles[m].url);
          if (asset) {
            asset.isInContent = true;
          }
        }
      }
      if (data[i].children && data[i].children.length) {
        this.findMedia(data[i].children);
      }
    }
  }

  private pushToTree(item, level): any {
    level += 1;
    item['translation'] = [];
    item['level'] = level;
    const children = [];
    (item?.children || []).forEach(id => {
      if (!this.children[id]) {
        return console.warn(id);
      }
      const subEntry = this.pushToTree(JSON.parse(JSON.stringify((this.children[id]))), level);
      subEntry.data.parent = item._id;
      children.push(subEntry);
    });
    children.sort(function(obj1, obj2) { return obj1.data.order - obj2.data.order });
    item.children = children.map(el => el.data);
    return { data: item, children: children };
  }

  changeModalTab(type) {
    this.changeTabModal.emit(type);
  }

  hover(item, event: any) {
    const imageContainer = document.createElement('div');
    const containerWidth = 500;
    const containerHeight = 500;
    imageContainer.id = 'media-img-preview-overlay'
    Object.assign(imageContainer.style, { position: 'absolute', width: `${containerWidth}px`, height: `${containerHeight}px`, zIndex: '1000', pointerEvents: 'none',
      display: 'flex', justifyContent: 'center', alignItems: 'center', left: `${event.clientX - containerWidth / 2}px`, top: `${Math.max(10, event.clientY - containerHeight)}px`
    });

    const wrapper = document.createElement('div');
    Object.assign(wrapper.style, { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' });

    imageContainer.appendChild(wrapper);

    const img = document.createElement('img');
    img.src = this.assetPath + item.path + '/raw';
    img.alt = 'Dynamic Image';
    Object.assign(img.style, {
      maxWidth: '100%', maxHeight: '100%', display: 'flex', flexDirection: 'row', justifySelf: 'center', border: '5px solid white', borderRadius: '5px',
      boxShadow: 'rgba(0, 0, 0, 0.75) 0px 0px 10px', background: 'repeating-conic-gradient(#CCC 0 25%, #FFF 0 50%) 0 / 10px 10px'
    });
    wrapper.appendChild(img);
    document.body.appendChild(imageContainer);
  }

  leave() {
    document.getElementById('media-img-preview-overlay')?.remove();
  }
}
